import React, { useEffect, useRef, useState } from "react";
import "./EditarOrigemCarregamentoTrilhosNovosModal.css";

const sanitizeCidadeInput = (value, max = 80) =>
  String(value ?? "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/[<>]/g, "")
    .toUpperCase()
    .slice(0, max);

const sanitizeCidadeSave = (value, max = 80) => sanitizeCidadeInput(value, max).trim();

const sanitizeUf = (value) =>
  String(value ?? "")
    .replace(/[^A-Za-z]/g, "")
    .trim()
    .toUpperCase()
    .slice(0, 2);

export default function EditarOrigemCarregamentoTrilhosNovosModal({ open, registro, onClose, onSalvar }) {
  const [cidade, setCidade] = useState("");
  const [uf, setUf] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const cidadeRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setCidade(sanitizeCidadeInput(registro?.cidade || ""));
    setUf(sanitizeUf(registro?.uf || ""));
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => cidadeRef.current?.focus(), 0);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
    };
  }, [open, registro]);

  if (!open) return null;

  async function handleSalvar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      const cidadeValue = sanitizeCidadeSave(cidade);
      const ufValue = sanitizeUf(uf);
      if (!cidadeValue) throw new Error("Informe a cidade.");
      if (!ufValue || ufValue.length !== 2) throw new Error("Informe a UF com 2 letras.");
      await onSalvar?.({ cidade: cidadeValue, uf: ufValue });
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar alteracoes.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ocned-overlay" onClick={onClose}>
      <div className="ocned-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Editar origem de carregamento novos">
        <div className="ocned-head">
          <h3 className="ocned-title">Editar Origem - Trilhos Novos</h3>
          <button className="ocned-close" type="button" onClick={onClose} disabled={busy} aria-label="Fechar">
            x
          </button>
        </div>

        <div className="ocned-body">
          <label className="ocned-field">
            <span>Cidade</span>
            <input
              ref={cidadeRef}
              type="text"
              value={cidade}
              onChange={(e) => setCidade(sanitizeCidadeInput(e.target.value))}
              autoComplete="off"
            />
          </label>
          <label className="ocned-field">
            <span>Estado (UF)</span>
            <input
              type="text"
              value={uf}
              onChange={(e) => setUf(sanitizeUf(e.target.value))}
              autoComplete="off"
            />
          </label>
          {err ? <div className="ocned-error">{err}</div> : null}
        </div>

        <div className="ocned-foot">
          <button className="ocned-btn ocned-btn-ghost" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="ocned-btn ocned-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar alteracoes"}
          </button>
        </div>
      </div>
    </div>
  );
}
